import AbsencesProvider from './AbsencesContext';
import Absences from './Absences';

let Index = () => {
    return (
        <AbsencesProvider>
            <Absences />
        </AbsencesProvider>
    )
}

export default Index;